import Rest from 'services/data/rest';
import axios from 'axios';
import Promise from 'bluebird';

// Actions
import { alerts } from 'modules/alerts/actions';

export default class Form extends Rest {
  static path = 'form';
  static defaultQuery = {
    sort: 'title',
    load: ['form', 'sheet']
  };

  static forceUpdate() {
    return Promise.resolve(axios.post('/api/form/update'))
      .tap(() => alerts.success({ title: 'Starting form update' }))
      .tap(this.logRequest)
      .then((response) => response.data);
  }
}



// WEBPACK FOOTER //
// ./app/services/data/form.js